import { ReactNode } from 'react'
import { Box, Paper, Typography } from '@mui/material'
import { SxProps } from '@mui/material/styles'
import { tokens } from '../theme'

interface SectionCardProps {
  title: string
  /** Volitelné "i" s vysvětlením výpočtu/pravidel hned za titulkem (InfoHint). */
  info?: ReactNode
  /** Volitelný prvek vpravo v hlavičce (tlačítko, chip…). */
  action?: ReactNode
  children: ReactNode
  sx?: SxProps
}

/**
 * Bílá karta s plnou navy hlavičkou — vizuální podpis apex-generatoru
 * přenesený do MUI (gradient primary.900 → primary.700).
 */
export function SectionCard({ title, info, action, children, sx }: SectionCardProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: `${tokens.radius.lg}px`,
        boxShadow: tokens.shadow.md,
        overflow: 'hidden',
        ...sx,
      }}
    >
      <Box
        sx={{
          background: `linear-gradient(135deg, ${tokens.primary[900]}, ${tokens.primary[700]})`,
          color: '#fff',
          px: 2,
          py: 1.5,
          minHeight: 48,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '0.9375rem',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
          >
            {title}
          </Typography>
          {info}
        </Box>
        {action}
      </Box>
      <Box sx={{ p: 2.5 }}>{children}</Box>
    </Paper>
  )
}
